<template>
    
    <v-app class="choose-profile">
        
        <v-main>
            <v-container fill-height fluid class="sign-page">
                <v-row class="sign-container">

                    <v-col cols="12"
                           lg="3"
                           class="sign-form text-center"
                           :style="signFormHeight">

                        <!--<v-alert v-if="$vuetify.breakpoint.mobile && (communicationsList || []).length>0"
                         :type="types[communicationsList[0].type]"
                         dismissible
                         :color="communicationsList[0].color">

                    <span v-html="communicationsList[0].description"></span>

                </v-alert>-->

                        <div></div>

                        <img :src="`${urlBundles.baseUrl}assets/passdelivery_grey.svg`"
                             class="logo" />
                        <v-form ref="form"
                                method="post"
                                id="nativeForm"
                                v-model="valid"
                                class="form"
                                autocomplete="one-time-code"
                                @submit.prevent="onSubmit">
                            <div class="text-h6 form-title">
                                {{ $t("pages.signin_signup.login") }}
                            </div>
                            <v-text-field :error-messages="usernameMessages"
                                          :error="(usernameMessages || []).length > 0"
                                          :rules="emailRules"
                                          :value="email"
                                          autocomplete="one-time-code"
                                          dense
                                          flat
                                          label="E-mail"
                                          name="Username"
                                          outlined
                                          ref="email"
                                          required
                                          type="email"
                                          v-model="email"></v-text-field>
                            <v-text-field :error-messages="passwordMessages"
                                          :error="(passwordMessages || []).length > 0"
                                          :rules="passwordRules"
                                          :value="password"
                                          autocomplete="one-time-code"
                                          dense
                                          flat
                                          label="Password"
                                          name="Password"
                                          outlined
                                          ref="password"
                                          required
                                          type="password"
                                          v-model="password"></v-text-field>
                            <input type="hidden"
                                   id="RequestVerificationToken"
                                   v-model="token"
                                   name="__RequestVerificationToken" />
                            <v-btn :disabled="!valid"
                                   @click="submit"
                                   block
                                   class="login-submit-btn"
                                   depressed
                                   ref="submit"
                                   tile
                                   type="submit">
                                {{ $t("pages.signin_signup.signin") }}
                            </v-btn>
                            <a class="reset-password-link"
                               @click="openResetPasswordDialog = true">
                                {{ $t("pages.signin_signup.resetPassword.forgotPassword") }}
                            </a>
                            <pd-errors :errorTypes="[0]"></pd-errors>
                        </v-form>
                        <div v-if="appVersion" style="font-size: 12px">
                            v.{{ appVersion }}
                        </div>

                    </v-col>

                    <v-col cols="12" lg="9">
                        <v-row style="height:15%">
                            <v-col cols="12" v-if="!$vuetify.breakpoint.mobile">
                                <v-carousel :show-arrows="false" height="auto" cycle>
                                    <v-carousel-item v-for="(news, i) in communicationsList" :key="i">
                                        <v-alert :type="types[news.type]"
                                                 prominent
                                                 :color="news.color">

                                            <span v-html="news.description"></span>

                                        </v-alert>
                                    </v-carousel-item>
                                </v-carousel>
                            </v-col>
                        </v-row>
                        <v-row style="height:85%">
                            <v-col cols="12" v-if="$vuetify.breakpoint.mobile">
                                <v-img :src="`${urlBundles.baseUrl}assets/powered-by-passepartout.svg`"
                                       position="center center"
                                       contain
                                       class="poweredby"
                                       :width="200"
                                       style="margin: 0 auto" />
                            </v-col>
                            <v-col cols="12" lg="3" v-if="!$vuetify.breakpoint.mobile"></v-col>
                            <v-col cols="12"
                                   lg="9"
                                   class="align-center payoff-container"
                                   v-if="!$vuetify.breakpoint.mobile">

                                <v-img :src="`${urlBundles.baseUrl}assets/powered-by-passepartout.svg`"
                                       position="center center"
                                       contain
                                       class="poweredby" />
                                <transition name="fade" v-on:leave="switchPayoff">
                                    <div class="payoff" v-if="show">{{ payoff }}</div>
                                </transition>
                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
            <reset-password-dialog :emailRules="emailRules"
                                   v-model="openResetPasswordDialog"
                                   @success="showEmailSnackbar()"
                                   @close="openResetPasswordDialog = false"></reset-password-dialog>
            <snackbar-hub></snackbar-hub>
            <communication-hub></communication-hub>

        </v-main>
        <pd-footer :color="'rgba(0,0,0,0)'"></pd-footer>
    </v-app>
</template>

<script>
    import { UrlBundles, UserInfo, ModelStateErrors, EventHub } from "Libs/core";
    import { mapGetters } from "vuex";

    import isMobile from "ismobilejs";
    import SnackbarHub from "Components/snackbar-hub";
    import ResetPasswordDialog from "./components/reset-password-dialog";
    import PdFooter from "Components/pd-footer";
    import PdErrors from "Components/pd-errors";
    import CommunicationHub from "Components/communication-hub";

    import * as g from "./store/types/getters.types";
    import * as a from "./store/types/actions.types";

    export default {
        components: { PdErrors, PdFooter, ResetPasswordDialog, SnackbarHub, CommunicationHub },
        data() {
            return {
                appVersion: null,
                isMobile: isMobile,
                eventHub: EventHub,
                show: true,
                payoffIndex: 0,
                payoffs: [
                    this.$t("payoffs.0"),
                    this.$t("payoffs.1"),
                    this.$t("payoffs.2"),
                    this.$t("payoffs.3"),
                    this.$t("payoffs.4"),
                ],
                token: window.RequestVerificationToken,
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                modelStateErrors: ModelStateErrors,
                valid: false,
                password: "",
                passwordRules: [
                    (v) => !!v || this.$t("forms.password_required"),
                    (v) => (v && v.length >= 8) || this.$tc("forms.password_validation", 8),
                ],
                email: "",
                emailRules: [
                    (v) => !!v || this.$t("forms.email_required"),
                    (v) => /.+@.+\..+/.test(v) || this.$t("forms.email_validation"),
                ],
                openResetPasswordDialog: false,
                types: [
                    //lasciare il primo slot come vuoto perch� l'enum lato server parte da 1
                    "", "success", "info", "warning", "error"
                ],
            };
        },
        computed: {
            ...mapGetters("communications", {
                communicationsList: g.GET_COMMUNICATIONS_LIST,
                communicationsLoading: g.GET_COMMUNICATIONS_LOADING
            }),
            signFormHeight() {
                return this.$vuetify.breakpoint.mobile ?  "height: 85%;" : "height: 100%;";
            },
            payoff() {
                return this.payoffs[this.payoffIndex];
            },
            passwordMessages() {
                let messages = [];
                this.modelStateErrors
                    .filter((error) => {
                        return error.code === "Password" && error.type === 1;
                    })
                    .map((error) => {
                        messages.push(error.description);
                    });
                return messages;
            },
            usernameMessages() {
                let messages = [];
                this.modelStateErrors
                    .filter((error) => {
                        return error.code === "Username" && error.type === 1;
                    })
                    .map((error) => {
                        messages.push(error.description);
                    });
                return messages;
            },
        },
        methods: {
            showEmailSnackbar() {
                this.eventHub.$emit("snackbar", {
                    bottom: true,
                    msg: this.$t("pages.signin_signup.resetPassword.dialogSuccess"),
                    type: "success",
                });
            },
            submit() {
                if (window.hasOwnProperty("JsInterface")) {
                    window.JsInterface.login(this.email, this.password);
                }
                if (this.isMobile(window.navigator).apple.device && window.webkit) {
                    window.webkit.messageHandlers.login.postMessage({
                        email: this.email,
                        password: this.password,
                    });
                }
                nativeForm.submit();
            },
            hidePayoff() {
                this.show = false;
                setTimeout(this.showPayoff, 1000);
            },
            showPayoff() {
                this.show = true;
                setTimeout(this.hidePayoff, 6000);
            },
            switchPayoff() {
                this.payoffIndex < this.payoffs.length - 1
                    ? this.payoffIndex++
                    : (this.payoffIndex = 0);
            },
            selfLogin(email, password) {
                this.email = email;
                this.password = password;
                this.$nextTick(() => {
                    this.submit();
                });
            },
            rememberUsername(email) {
                this.email = email;
            },
            loadCommunications() {
                return this.$store.dispatch("communications/" + a.LOAD_COMMUNICATIONS, {
                    destination: 0,
                });
            },
            getIcon(type) {
                switch (type) {
                    case 1:
                        return "mdi-check-circle";
                        break;
                    case 2:
                        return "mdi-information";
                        break;
                    case 3:
                        return "mdi-exclamation";
                        break;
                    case 4:
                        return "mdi-alert";
                        break;
                }
            },
        },
        mounted() {
            this.appVersion = (window.VERSION || {}).VERSION_DESC;


            setTimeout(this.hidePayoff, 6000);

            this.$nextTick(() => {
                // this.$refs.email.focus();
                this.loadCommunications().then(() => {
                    if (this.$vuetify.breakpoint.mobile) {
                        for (let i = 0; i < this.communicationsList.length; i++) {
                            var communication = this.communicationsList[i];
                            this.eventHub.$emit("communication", {
                                top: true,
                                right: true,
                                duration: 15000,
                                icon: this.getIcon(communication.type),
                                msg: communication.description,
                                color: communication.color,
                            });
                        }
                    }
                });           
            });

            if (
                this.modelStateErrors.length > 0 &&
                window.hasOwnProperty("JsInterface")
            ) {
                window.JsInterface.logout();
            }

            if (
                this.modelStateErrors.length > 0 &&
                this.isMobile(window.navigator).apple.device &&
                window.webkit
            ) {
                window.webkit.messageHandlers.logout.postMessage({});
            }

            if (
                window.hasOwnProperty("JsInterface") ||
                (this.isMobile(window.navigator).apple.device && window.webkit)
            ) {
                window.selfLogin = this.selfLogin;
                window.rememberUsername = this.rememberUsername;
            }
        },
    };
</script>

<style lang="scss">

    .v-carousel__controls {
        background: transparent !important;
        margin-top: -20px !important;
        position: relative !important;
    }

    .v-carousel__controls__item {
        color: grey !important
    }

    .login-submit-btn {
        margin: 5px 0 20px;
        background: linear-gradient( 90deg, rgba(#bd1918, 1) 0%, rgba(#4b1818, 1) 100% );

        &.v-btn--disabled {
            background: transparent;
        }

        .v-btn__content {
            color: #fff;
        }
    }

    .sign-page {
        padding: 0 12px;

        .sign-container {
            height: 100%;

            .sign-form {
                align-items: center;
                background: #fff;
                box-shadow: 0 0 8px rgb(0 0 0 / 51%);
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .logo {
                    width: 260px;
                }

                .form {
                    width: 260px;
                }
            }
        }
    }

    .payoff-container {
        display: flex;

        .poweredby {
            bottom: 30px;
            position: absolute;
            right: 30px;
            width: 180px;
            height: 50px;
        }

        .payoff {
            color: #fff;
            font-size: 32px;
            padding-right: 30px;
            text-align: right;
            width: 100%;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .form-title {
        margin-bottom: 30px;
        color: #5b5b5b;
    }

    .reset-password-link {
        font-size: 15px;
    }

    .reset-password-link:hover {
        text-decoration: underline;
    }   
</style>
